export default "__VITE_ASSET__BhnSBFEJ__"